import { useQuery, useMutation } from "@tanstack/react-query";
import { RunTenantSql, GetTenantTables, GetTenantSchema } from "../Api";
import { ServiceQueryOptions, unwrapApiResponse } from "./query_helpers";
import { LOOKUP_STALE_TIME } from "../Constant/AppConstants";

export const sqlToolQueryKeys = {
  tables: (tenantId?: string) => ["sqlToolTables", tenantId] as const,
  schema: (tenantId?: string) => ["sqlToolSchema", tenantId] as const,
};

export const useTenantTablesQuery = (
  tenantId?: string,
  options?: ServiceQueryOptions,
) => {
  return useQuery({
    staleTime: LOOKUP_STALE_TIME,
    ...options,
    queryKey: sqlToolQueryKeys.tables(tenantId),
    queryFn: async () =>
      unwrapApiResponse(await GetTenantTables({ tenant_id: tenantId })),
  });
};

export const useTenantSchemaQuery = (
  tenantId?: string,
  options?: ServiceQueryOptions,
) => {
  return useQuery({
    staleTime: LOOKUP_STALE_TIME,
    ...options,
    queryKey: sqlToolQueryKeys.schema(tenantId),
    queryFn: async () =>
      unwrapApiResponse(await GetTenantSchema({ tenant_id: tenantId })),
  });
};

export const useRunTenantSqlMutation = () => {
  return useMutation({
    mutationFn: (payload: { tenant_id: string; sql: string }) =>
      RunTenantSql(payload),
  });
};
